<template>
  <div class="edit-video-box">
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="400px"
        :before-close="handleClose"
        :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="账号:" prop="name">
          <el-input
              v-model.trim="params.name"
              :disabled="title !== '新增管理员'"
              size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名:" prop="nickname">
          <el-input v-model.trim="params.nickname" size="small"></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="passWord">
          <el-input v-model.trim="params.passWord" size="small"></el-input>
        </el-form-item>
        <el-form-item label="角色:" prop="privilegeID">
          <el-select v-model="params.privilegeID" size="small">
            <el-option
                v-for="item in privilegeIDList"
                :value="item.value"
                :label="item.label"
                :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱:" prop="email">
          <el-input v-model="params.email" type="email" size="small"></el-input>
        </el-form-item>
        <el-form-item label="是否封禁:" prop="hasLocked">
          <el-switch
              active-text="是"
              inactive-text="否"
              v-model="params.hasLocked"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="flag"
            size="small"
        >确 认
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import {validatorHanzi} from '@/utils/validator'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      privilegeIDList: [],
      params: {
        name: '',
        passWord: '',
        nickname: '',
        email: '',
        privilegeID: '',
        hasLocked: ''
      },
      rules: {
        nickname: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        name: [{required: true, message: '请输入名称', trigger: 'blur'}],
        passWord: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: validatorHanzi, trigger: 'blur'}
        ],
        email: [
          {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'},
        ],
        privilegeID: [{required: true, message: '请选择角色', trigger: 'blur'},],
      }
    }
  },
  computed: {},
  created() {
    this.getRoleList()
  },
  mounted() {
  },
  methods: {
    // 获取角色/权限列g
    getRoleList() {
      let params = {
        pageNumber: 1,
        pageSize: 20
      }
      this.getAuthorList(params)
    },
    getAuthorList(params) {
      API.getAuthorList(params).then(res => {
        if (res.code === 200 && res.data) {
          this.privilegeIDList = this.privilegeIDList.concat(res.data.list.map(item => {
            return {
              label: item.role,
              value: item.id
            }
          }))
          if (params.pageNumber * params.pageSize < res.data.total) {
            params.pageNumber += 1
            this.getAuthorList(params)
          } else {
            return false
          }
        }
      })
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '新增管理员') {
            this.addAdm()
          } else {
            this.editAdm()
          }
        } else {
          return false;
        }
      });
    },
    addAdm() {
      let params = Object.assign(this.params, {id: this.id});
      API.addAdm(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerAdmList')
        } else if (res.code === 9100) {
          this.$message.error('新增失败,该管理员已存在');
        } else {
          this.$message.error('新增失败,请重试');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    editAdm() {
      let params = Object.assign(this.params, {adminID: this.id});
      API.updateAdm(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerAdmList')
        } else {
          this.$message.error('编辑失败,请重试');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        name: '',
        passWord: '',
        nickname: '',
        email: '',
        privilegeID: '',
        hasLocked: ''
      }
      this.$refs.form.resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑管理员'
        this.params.name = data.name
        this.params.nickname = data.nickname
        this.params.email = data.email
        this.params.privilegeID = data.privilegeID
        this.params.passWord = data.password
        this.id = data.id,
            this.params.hasLocked = data.hasLocked
      } else {
        this.title = '新增管理员'
      }
    }
  }

}
</script>

<style lang="scss">
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100% !important;
  }

  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
